<template>
  <ion-page>
    <main-header>
      <ion-toolbar color="light">
        <ion-title class="ion-text-center">Place an Order</ion-title>
        <ion-buttons v-if="itemsCount && user" slot="end">
          <ion-button
            color="primary"
            fill="solid"
            class="ion-margin-end"
            @click="goToCheckout()"
            data-cy="checkout-button"
          >
            Checkout
          </ion-button>
          <ion-badge color="success">
            {{ itemsCount }}
          </ion-badge>
        </ion-buttons>
      </ion-toolbar>
    </main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <div
          v-if="!menu"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          There are no menu items available.
        </div>
        <ion-list v-else data-cy="menu-list">
          <div
            v-for="(category, index) in categories"
            :key="`category-${index}`"
          >
            <ion-list-header :class="{ 'ion-margin-top': index != 0 }">
              <h3>{{ category.name }}</h3>
            </ion-list-header>

            <ion-item
              v-for="item in category.items"
              :key="`item-${item.id}`"
              detail
              button
              @click="addItem(item)"
              :data-cy="`item-${item.id}`"
            >
              <ion-label>
                {{ item.name }}
                <p v-if="item.price">{{ item.price | usd }}</p>
              </ion-label>
              Add
            </ion-item>
          </div>
        </ion-list>
      </div>
    </ion-content>
    <available-order-footer></available-order-footer>
  </ion-page>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import errorAlert from "@/ErrorAlert";
import Menu from "@/models/Menu";
import AddItemModal from "@/components/App/AddItemModal";

export default {
  title() {
    return this.location.name;
  },

  data: function() {
    return {
      loading: true,
      menu: null
    };
  },

  created() {
    this.$firestore()
      .collection("menus")
      .withConverter(Menu.firebaseConverter)
      .doc(this.location.id)
      .get()
      .then(querySnapshot => {
        let menu = querySnapshot.data();
        if (menu) {
          menu.removeRestrictedItemsFromSelf();
        }

        this.menu = menu;
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapMutations("order", ["addItemToOrder"]),

    addItem(item) {
      if (this.user) {
        this.$ionic.modalController
          .create({
            component: AddItemModal,
            componentProps: {
              propsData: {
                closeModal: () => {
                  this.$ionic.modalController.dismiss();
                },

                /** vuex wasn't availabe in the model no matter how I imported it */
                addItemToOrder: payload => {
                  this.addItemToOrder(payload);
                },

                item
              }
            }
          })
          .then(m => m.present());
      } else {
        this.$router.push({ name: "Sign Up" }).catch(e => e);
      }
    },

    goToCheckout() {
      this.$router.push({ name: "App: Order Review and Confirm" });
    }
  },

  computed: {
    ...mapGetters("order", {
      location: "orderLocation",
      itemsCount: "itemsCount"
    }),

    ...mapGetters("auth", ["user"]),

    categories() {
      return (
        (this.menu &&
          this.menu.categories &&
          Array.isArray(this.menu.categories) &&
          this.menu.categories.filter(
            category => category.items && category.items.length
          )) ||
        []
      );
    }
  }
};
</script>

<style type="scss">
ion-button + ion-badge {
  position: absolute;
}
.md ion-button + ion-badge {
  right: 0;
  top: -10px;
}
.ios ion-button + ion-badge {
  right: -3px;
  top: -2px;
}
</style>
